export default "__VITE_ASSET__DFm0Lhmn__"